<template>
  <!-- Implementa la tabella per la visualizzazione degli ordini caricati
       in piattapasto con la relativa visualizzazione dello stato degli stessi.
       Implementa gli eventi:
       - @backToMainMenu: richiesta di tornare al menù principale. -->
  <div>
    <!-- PULSANTE RITORNO AL MENU' PRINCIPALE -->
    <b-row class="mt-5 mb-5">
      <b-col>
        <b-button variant="primary" @click="emit_return_to_menu_event()">
          <b-icon icon="arrow-left-short"></b-icon> Torna al menù
        </b-button>
      </b-col>
    </b-row>
    <!-- SELECT PER LE RIGHE VISUALIZZABILI -->
    <b-row>
      <b-col cols="12" md="2">
        <h4>Status ordini</h4>
        <b-form-group id="group-n-righe-per-pagina"
          label="Righe per pagina:"
          label-for="n_elementi"
        >
          <b-form-select id="n_righe_per_pagina"
            v-model="datatable.per_page"
            :options="datatable.righe_per_pagina">
            </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <!-- LA TABELLA DEGLI ORDINI -->
    <b-row>
      <b-col>
        <b-table hover stacked="md"
                  :items="get_table_items"
                  :no-provider-sorting="true"
                  :fields="datatable.fields"
                  :current-page="datatable.current_page"
                  :per-page="datatable.per_page"
                  show-empty>

          <!-- TABLE BUSY SLOT -->
          <!-- Spinner che informa del caricamento dati attivato dalla tabella quando viene
                chiamata la funzione che prende i dati get_table_items --->
          <template v-slot:table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle mr-2" variant="primary"></b-spinner>
              <strong class="text-primary">Caricamento...</strong>
            </div>
          </template>

          <!-- CREATED SLOT -->
          <!-- Slot della data created, data di caricamento dell'ordine -->
          <!-- la riportiamo nel formato italiano, se non disponibile   -->
          <!-- visualizziamo un trattino -->
          <template v-slot:cell(created)="data">
            <p v-if="data.value">{{data.value|toitadatetime}}</p>
            <p v-else>-</p>
          </template>

          <!-- START_TIME SLOT -->
          <!-- Slot dello start_time, data di inizio immissione ordine -->
          <!-- la riportiamo nel formato italiano, se non disponibile  -->
          <!-- visualizziamo un trattino -->
          <template v-slot:cell(start_time)="data">
            <p v-if="data.value">{{data.value|toitadatetime}}</p>
            <p v-else>-</p>
          </template>

          <!-- STOP_TIME SLOT -->
          <!-- Slot dello stop_time, data di fine immissione ordine   -->
          <!-- la riportiamo nel formato italiano, se non disponibile -->
          <!-- visualizziamo un trattino -->
          <template v-slot:cell(stop_time)="data">
            <p v-if="data.value">{{data.value|toitadatetime}}</p>
            <p v-else>-</p>
          </template>

          <!-- STATUS SLOT -->
          <!-- Slot della stringa status che indica in quale stato si -->
          <!-- trova l'ordine, facciamo in modo che la stringa appaia -->
          <!-- in colorazioni differenti a seconda dello stato e con  -->
          <!-- tooltip esplicativo.                                   -->
          <template v-slot:cell(status)="data">
            <span v-if="data.value==='TO_VALIDATE'"    style="color:#858585" v-b-tooltip.hover.leftbottom="'Ordine in attesa di validazione'" class="font-weight-bold font-italic">DA VALIDARE</span>
            <span v-else-if="data.value==='VALID'"     style="color:#fa8100" v-b-tooltip.hover.leftbottom="'Ordine validato, in attesa di immissione nel sistema'" class="font-weight-bold font-italic">VALIDO</span>
            <span v-else-if="data.value==='STARTED'"   style="color:#ffdd00" v-b-tooltip.hover.leftbottom="'Ordine in corso di immissione'" class="font-weight-bold font-italic">IN CORSO</span>
            <span v-else-if="data.value==='COMPLETED'" style="color:#15a100" v-b-tooltip.hover.leftbottom="'Ordine completato correttamente'" class="font-weight-bold font-italic">COMPLETATO</span>
            <span v-else-if="data.value==='ERROR'"     style="color:#cf0e00" v-b-tooltip.hover.leftbottom="'Ordine completato con errori, alcuni utenti non sono stati processati correttamente. Visualizza il dettaglio errori per maggiori informazioni'" class="font-weight-bold font-italic">ERRORE</span>
            <span v-else>{{data.value}}</span>
          </template>

          <!-- JSON_DATA SLOT -->
          <!-- Slot con il json dei dati caricati, visualizza un bottone -->
          <!-- il quale mostra la modale per vedere tali dati -->
          <template v-slot:cell(json_data)="data">
            <b-button variant="primary" size="sm" pill @click="visualizza_dettagli_caricamento( data.value, data.item.json_error_detail )">
              <b-icon icon="search" scale="0.7"></b-icon> Visualizza
            </b-button>
          </template>

          <!-- JSON_ERROR_DETAIL SLOT -->
          <!-- Slot con il json dei dati caricati, visualizza un bottone -->
          <!-- il quale mostra la modale per vedere tali dati -->
          <template v-slot:cell(json_error_detail)="data">
            <b-button v-if="data.value || data.item.forn_error" variant="danger" size="sm" pill @click="visualizza_dettagli_errore(data.value, data.item.forn_error)">
              <b-icon icon="search" scale="0.7"></b-icon> Visualizza
            </b-button>
            <p v-else><i>Nessuno</i></p>
          </template>

          <!-- EMPTY SLOT -->
          <!-- Slot che visualizza un messaggio quando la tabella non ha elementi, deve essere aggiunta
                la proprietà "show-empty" alla tabella -->
          <template v-slot:empty>
            <p class="text-center"><font-awesome-icon icon="exclamation-circle" size="lg"/>  Nessun elemento da visualizzare</p>
          </template>

          <!-- EMPTYFILTERED SLOT -->
          <!-- Slot che visualizza un messaggio quando il filtro non restituisce risultati, deve essere aggiunta
                la proprietà "show-empty" alla tabella -->
          <template v-slot:emptyfiltered>
            <p class="text-center"><font-awesome-icon icon="exclamation-circle" size="lg"/>  Nessun elemento trovato</p>
          </template>
        </b-table>
        <b-pagination v-model="datatable.current_page" :total-rows="datatable.total_rows" :per-page="datatable.per_page" align="center"></b-pagination>
      </b-col>
    </b-row>

    <!-- MODALE PER DETTAGLIO DATI CARICATI DI UN ORDINE -->
    <b-modal v-model="order_detail_modal.show"
          no-close-on-backdrop
          no-close-on-esc
          scrollable
          size='lg'
          title="Dettaglio dell'ordine"
          @hidden="reset_order_detail_modal_content()">
      <!-- Corpo della modale: tabella riassuntiva dei dati caricati -->
      <template v-slot:default>
        <p>
          Se <span class="text-danger font-italic">l'ordine viene segnalato come in errore</span> controllare il <b>dettaglio
          errori</b> per informazioni.
        </p>
        <p>
          Eventuali <span class="text-danger font-italic">utenti segnalati in rosso </span> nella lista sottostante hanno
          incontrato un problema di gestione all'interno della piattaforma Welfarebit, ed <b>il loro nominativo non è stato
          inoltrato</b> al fornitore dei buoni pasto ( se definito ). Controllare il <b>dettaglio errori</b> per informazioni.
        </p>
        <b-table-simple hover small caption-top responsive>
          <b-thead>
            <b-tr>
              <b-th>Utente</b-th>
              <b-th>Email Utente</b-th>
              <b-th class="text-center">Buoni Richiesti</b-th>
              <b-th class="text-center">Importo €</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="( elem, index ) in order_detail_modal.modal_data" :key="index">
              <b-td v-if="elem.error" class="text-danger font-italic">{{elem.nome}}</b-td>
              <b-td v-else>{{elem.nome}}</b-td>
              <b-td v-if="elem.error" class="text-danger font-italic">{{elem.email}}</b-td>
              <b-td v-else>{{elem.email}}</b-td>
              <b-td v-if="elem.error" class="text-center text-danger font-italic">{{elem.nbuoni}}</b-td>
              <b-td v-else class="text-center">{{elem.nbuoni}}</b-td>
              <b-td v-if="elem.error" class="text-center text-danger font-italic">{{elem.val_buoni}}</b-td>
              <b-td v-else class="text-center">{{elem.val_buoni}}</b-td>
            </b-tr>
          </b-tbody>
          <b-tfoot>
            <b-tr>
              <b-td colspan="2"><b><i>Tot</i></b></b-td>
              <b-td class="text-center">
                <b><i>{{order_detail_modal.buoni_total}}</i></b>
              </b-td>
              <b-td class="text-center">
                <b><i>{{order_detail_modal.order_total}} €</i></b>
              </b-td>
            </b-tr>
          </b-tfoot>
        </b-table-simple>
      </template>
      <!-- Footer della modale: mostriamo solo il pulsante per chiudere la modale -->
      <template v-slot:modal-footer="{ok}">
        <b-button size="sm" variant="primary" @click="ok()">
          Ok
        </b-button>
      </template>
    </b-modal>

    <!-- MODALE PER DETTAGLIO ERRORI DI UN ORDINE -->
    <b-modal v-model="error_detail_modal.show"
          no-close-on-backdrop
          no-close-on-esc
          scrollable
          size='lg'
          title="Dettaglio degli errori occorsi durante l'esecuzione dell'ordine"
          @hidden="reset_error_detail_modal_content()">
      <!-- Corpo della modale: tabella riassuntiva degli errori più errore dell'ftp -->
      <template v-slot:default>
        <!-- Visualizzazione errori di invio al fornitore -->
        <h5>Esito invio al fornitore dei buoni pasto:</h5>
        <div v-if="error_detail_modal.forn_error_string">
          <p class='text-danger'>
            Errore nella procedura di invio ordine al fornitore, contattare l'assistenza welfarebit
            per ulteriori informazioni:
          </p>
          <b-card class="font-italic font-weight-light mb-4">
            {{error_detail_modal.forn_error_string}}
          </b-card>
        </div>
        <div v-else>
          <p class='text-success'>
            Invio ordine al fornitore concluso con successo.
          </p>
          <p>
            Eventuali utenti presenti nella tabella sottostante <u>non sono stati inclusi</u> nei nominativi
            inviati al fornitore a causa di errori nella piattaforma welfarebit, verifica il dettaglio qui
            sotto per maggiori informazioni.
          </p>
        </div>
        <!-- Visualizzazione errori singoli utenti -->
        <h5>Esito ordine nella piattaforma Welfarebit:</h5>
        <div v-if="error_detail_modal.modal_data.length > 0">
          <p class='text-danger'>Utenti per la quale non è stato possibile effettuare l'ordine:</p>
          <b-table-simple hover small caption-top responsive>
            <b-thead>
              <b-tr>
                <b-th>Utente</b-th>
                <b-th>Email Utente</b-th>
                <b-th>Errore</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="( elem, index ) in error_detail_modal.modal_data" :key="index">
                <b-td>{{elem.nome}}</b-td>
                <b-td>{{elem.email}}</b-td>
                <b-td>{{elem.error}}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>
        <div v-else>
          <p>Nessun errore presente</p>
        </div>
      </template>
      <!-- Footer della modale: mostriamo solo il pulsante per chiudere la modale -->
      <template v-slot:modal-footer="{ok}">
        <b-button size="sm" variant="primary" @click="ok()">
          Ok
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'StatusOrdini',
  data () {
    return {

      // Oggetto con le info per la tabella degli ordini
      datatable : {
        // Definizione delle colonne per la tabella.
        fields: [
          {
            key: 'created',
            label: 'Data caricamento',
            sortable: true,
            class: "text-center",
            thStyle: { backgroundColor: '#b3b3b3' }
          },
          {
            key: 'start_time',
            label : 'Data inizio immissione a sistema',
            sortable: true,
            class: "text-center",
            thStyle: { backgroundColor: '#b3b3b3' }
          },
          {
            key: 'stop_time',
            label : 'Data completamento',
            sortable: true,
            class: "text-center",
            thStyle: { backgroundColor: '#b3b3b3' }
          },
          {
            key : 'status',
            label : 'Status ordine',
            sortable: true,
            class: "text-center",
            thStyle: { backgroundColor: '#b3b3b3' }
          },
          {
            key : 'json_data',
            label : 'Dati caricati',
            sortable: false,
            class: "text-center",
            thStyle: { backgroundColor: '#b3b3b3' }
          },
          {
            key : 'json_error_detail',
            label : 'Dettaglio errori',
            sortable: false,
            class: "text-center",
            thStyle: { backgroundColor: '#b3b3b3' }
          }
        ],

        // Elementi per pagina selezionabili
        righe_per_pagina : [
          { value: 5, text: "5" },
          { value: 10, text: "10" },
          { value: 25, text: "25" },
          { value: 50, text: "50" },
          { value: 100, text: "100" },
          { value: 200, text: "200" }
        ],

        // Pagina corrente
        current_page : 1,

        // Elementi visualizzabili per pagina, viene modificato
        // dal valore di "righe_per_pagina"
        per_page : 5,

        // Righe totali
        total_rows : 0
      },

      // Oggetto per modale dei dettagli di un ordine
      order_detail_modal : {
        // Visualizza o meno la modale
        show : false,
        // Dati da mostrare
        modal_data : [],
        // Totale numero buoni
        buoni_total : 0,
        // Totale in euro
        order_total : 0
      },

      error_detail_modal : {
        // Visualizza o meno la modale
        show : false,
        // Eventuale errore nell'invio dati
        // al fornitore esterno
        forn_error_string : null,
        // Dati da mostrare
        modal_data : []
      }

    }
  },
  methods : {
    /**
     * Emette l'evento backToMainMenu che segnala alla vista
     * la necessità di tornare al menù principale.
     */
    emit_return_to_menu_event : function () {
      this.$emit( 'backToMainMenu' );
    },
    /**
     * Interroga il backend e torna gli elementi per popolare la tabella.
     *
     * - ctx: è la variabile di contesto che ci serve per interrogare in maniera corretta il backend
     *        questa contiene le chiavi:
     *                   apiUrl: ""      : url da chiamare, nel nostro caso stringa vuota. Perchè chiamiamo l'url nell funzione e non usiamo la prop
     *                   currentPage: 1  : pagina da chiamare
     *                   filter: null    : variabile di filtro, null oppure pari alla stringa che vogliamo filtare ( NON LO USIAMO IN QUESTA TABELLA )
     *                   perPage: 50     : numero di risultati per pagina
     *                   sortBy: ""      : stringa vuota a nome della colonna secondo il quale ordinare i dati ( VIENE FATTO LATO CLIENT - usiamo no-provider-sorting )
     *                   sortDesc: false : ordine di sorting, sempre presente, può essere true o false
     *
     * - callback: funzione di callback da chiamare quando i dati sono pronti.
     */
    get_table_items : function (ctx, callback) {

      let get_params = { page : ctx.currentPage, page_size : ctx.perPage };

      axios.get( apiUrl.piattapastoapi.storico_ordini, { params : get_params } )
      .then( (response) => {
        // Settiamo il numero totale di righe e torniamo i dati
        this.datatable.total_rows = response.data.count;
        callback ( response.data.results );
      })
      .catch( (error) => {
        // In caso di errore non apriamo un box informativo ma scriviamo direttamente
        // in console erestituiamo un'array vuota
        console.error( error );
        callback ( [] );
      });
    },
    /**
     * Visualizza la modale che mostra i dettagli di questo caricamento
     * aggiunge ai dati un flag utile al motore di rendering per sapere
     * se un utente caricato è andato in errore o meno per poterlo comunicare
     * visivamente all'utente.
     *
     * - data: array dei dati caricati letti dal backend
     * - error_dettail: array degli errori letti dal backend
     */
    visualizza_dettagli_caricamento : function ( data, error_detail ) {

      // Prendiamo le email degli utenti andati in errore ( se non sono null )
      // per poterli poi identificare nel ciclo sotto.
      let email_utenti_in_errore = [];
      if ( error_detail !== null ) {
        email_utenti_in_errore = error_detail.map( ( x ) => { return x.email });
      }

      // Popoliamo l'oggetto della modale con i dati del backend
      // aggiungendo però un flag che indica se quell'utente è andato
      // in errore o meno per segnalarlo all'utente.
      for ( let elem of data) {
        // Aggiungiamo quindi il flag error che se true indica che l'utente
        // caricato è in errore, se false è invece ok
        elem.error = email_utenti_in_errore.includes( elem.email ) ? true : false;
        this.order_detail_modal.modal_data.push( elem );
        this.order_detail_modal.order_total += elem.val_buoni;
        this.order_detail_modal.buoni_total += elem.nbuoni;
      }

      // Visualizziamo la modale
      this.order_detail_modal.show = true
    },
    /**
     * Resetta il contenuto della modale di dettaglio dell'ordine
     */
    reset_order_detail_modal_content : function () {
      this.order_detail_modal.modal_data = new Array();
      this.order_detail_modal.order_total = 0;
      this.order_detail_modal.buoni_total = 0;
    },
    /**
     * Visualizza la modale che mostra i dettagli degli
     * errori occorsi durante il caricamento dell'ordine
     *
     *  - data: array degli errori letti dal backend.
     *  - forn_error_string: stringa dell'eventuale errore occorso con il
     *                       fornitore.
     */
    visualizza_dettagli_errore : function ( data, forn_error_string ) {
      // Popoliamo l'oggetto della modale con i dati
      this.error_detail_modal.modal_data = data;
      this.error_detail_modal.forn_error_string = forn_error_string;
      // La visualizziamo
      this.error_detail_modal.show = true;
    },
    /**
     * Resetta il contenuto della modale con i dettagli
     * degli errori occorsi durante l'ordine.
     */
    reset_error_detail_modal_content : function () {
      this.error_detail_modal.modal_data = new Array();
    }
  }
}
</script>

<style scoped>
</style>